import YButton from './src/main'

YButton.install = function(Vue) {
  Vue.component(YButton.name, YButton)
}

export default YButton
